import React from "react";
import { FaUser, FaEnvelope, FaIdBadge, FaBuilding, FaPhone, FaCalendarAlt, FaUserTie, FaMapMarkerAlt } from "react-icons/fa";

export default function EmpProfile() {
  const employee = {
    name: "John Doe",
    employeeId: "EMP1234",
    email: "john@company.com",
    department: "Development",
    role: "Software Engineer",
    phone: "+91 9876543210",
    doj: "01-Jan-2022",
    manager: "Jane Smith",
    location: "Bangalore, India",
  };

  return (
    <div className="p-6 bg-gradient-to-r from-purple-100 via-pink-50 to-yellow-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">My Profile</h2>

      <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col md:flex-row items-center md:items-start space-y-6 md:space-y-0 md:space-x-10">

        {/* Avatar */}
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full bg-gradient-to-tr from-purple-400 via-pink-400 to-yellow-400 flex items-center justify-center text-white text-6xl shadow-lg">
            <FaUser />
          </div>
          <p className="mt-4 text-gray-800 font-bold text-lg">{employee.name}</p>
          <p className="text-gray-600 font-medium">{employee.role}</p>
        </div>

        {/* Profile Details */}
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-6">
          <ColorfulProfileField icon={<FaIdBadge />} label="Employee ID" value={employee.employeeId} color="from-blue-400 to-blue-200" />
          <ColorfulProfileField icon={<FaEnvelope />} label="Email" value={employee.email} color="from-green-400 to-green-200" />
          <ColorfulProfileField icon={<FaBuilding />} label="Department" value={employee.department} color="from-purple-400 to-purple-200" />
          <ColorfulProfileField icon={<FaUserTie />} label="Manager" value={employee.manager} color="from-pink-400 to-pink-200" />
          <ColorfulProfileField icon={<FaPhone />} label="Phone" value={employee.phone} color="from-yellow-400 to-yellow-200" />
          <ColorfulProfileField icon={<FaCalendarAlt />} label="Date of Joining" value={employee.doj} color="from-red-400 to-red-200" />
          <ColorfulProfileField icon={<FaMapMarkerAlt />} label="Location" value={employee.location} color="from-indigo-400 to-indigo-200" />
        </div>
      </div>
    </div>
  );
}

// Reusable colorful field component
function ColorfulProfileField({ icon, label, value, color }) {
  return (
    <div className={`flex items-center space-x-3 p-4 rounded-xl shadow-md bg-gradient-to-r ${color} text-white transform hover:scale-105 transition-transform`}>
      <div className="text-2xl">{icon}</div>
      <div>
        <p className="text-sm opacity-80">{label}</p>
        <p className="font-semibold text-lg">{value}</p>
      </div>
    </div>
  );
}
